import axios from 'axios';
import React, { Component } from 'react'
import swal from 'sweetalert';
//import Cookies from 'universal-cookie';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ApiUrl } from '../../services/ApiRest';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import './matricula.css';

const cookie = new Cookies();
const UrlListarPeriodosCreditosExtra = ApiUrl + "periodos-creditos-extra-estudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarNotasCreditosExtra = ApiUrl + "creditosext-estudiante-periodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

export default class ListarCreditosExtraMatricu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            periodos: [],
            notas: [],
            periodoSeleccionado: "",
            idEstudiante: '', // este debe venir de props o cookies si es un login
        };
    }

    componentDidMount() {
        // Puedes usar cookies o props para obtener el ID real del estudiante
        const idEstudiante = cookie.get("idEstudiante"); // reemplaza con cookie si es necesario
        this.setState({ idEstudiante }, () => {
            this.cargarPeriodos();
        });
    }

    cargarPeriodos = () => {
        axios.get(UrlListarPeriodosCreditosExtra, {
            params: {
                idEstudiante: this.state.idEstudiante,
            }
        }).then(res => {
            this.setState({ periodos: res.data.data });
        });
    };

    seleccionarPeriodo = (e) => {
        const periodoSeleccionado = Number(e.target.value);
        this.setState({ periodoSeleccionado }, () => {
            this.obtenerNotas();
        });
    }

    obtenerNotas = () => {
        const { idEstudiante, periodoSeleccionado } = this.state;
        axios.get(UrlListarNotasCreditosExtra, {
            params: {
                id_estudiante: idEstudiante,
                id_periodo_academico: periodoSeleccionado,
            }
        }).then(res => {
            this.setState({ notas: res.data });
        });
    }

    calcularPromedioFinal = (nota) => {
        const p = (Number(nota.parcial1) + Number(nota.parcial2) + Number(nota.parcial3)) / 3;
        const exFinal = Number(nota.examen_final);
        const exSusp = Number(nota.examen_suspension);
        const final = (p * 0.6) + (exFinal * 0.4) + (exSusp || 0);
        return final.toFixed(2);
    }

    promParciales = (n) => {
        const { parcial1, parcial2, parcial3 } = n;
        const totalParciales = Number(parcial1) + Number(parcial2) + Number(parcial3);
        return (totalParciales / 30 * 6).toFixed(2); // porque 3 parciales * 10 = 30, y lo pasamos a base 6
    };

    promExFinal = (n) => {
        return (Number(n.examen_final) / 10 * 4).toFixed(2); // examen sobre 10 → base 4
    };

    promAcumulado = (n) => {
        const p6 = parseFloat(this.promParciales(n));
        const p4 = parseFloat(this.promExFinal(n));
        return (p6 + p4).toFixed(2); // final sobre 10
    };
    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-graduation-cap bounce-custom"></i>
                        <b>Mis Créditos Extra - Notas por Período</b>
                    </div>


                    <div className="p-3 rounded-3 mt-3">
                        <h6 className="text-azul fw-bold">Seleccione un período académico:</h6>
                        <select className="form-select form-select-sm w-auto mb-4" onChange={this.seleccionarPeriodo}>
                            <option value="">-- Seleccione --</option>
                            {this.state.periodos.map(p => (
                                <option key={p.id_periodo_academico} value={p.id_periodo_academico}>{p.descripcion_periodo_academico}</option>
                            ))}
                        </select>


                        {this.state.notas.length > 0 && (
                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className='text-azul'>
                                        <tr>
                                            <th>Crédito</th>
                                            <th>P1</th>
                                            <th>P2</th>
                                            <th>P3</th>
                                            <th>Prom. Parciales (6)</th>
                                            <th>Ex. Final (4)</th>
                                            <th>Suspensión</th>
                                            <th>Prom. Final (10)</th>
                                            <th>Estado</th>
                                            <th>Asistencia</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.notas.map(n => (
                                            <tr key={n.id} className="text-azul">
                                                <td>{n.credito_extra?.descripcion || '-'}</td>
                                                <td>{n.parcial1}</td>
                                                <td>{n.parcial2}</td>
                                                <td>{n.parcial3}</td>
                                                <td>{this.promParciales(n)}</td>
                                                <td>{this.promExFinal(n)}</td>
                                                <td>{n.examen_suspension}</td>
                                                <td>{this.calcularPromedioFinal(n)}</td>
                                                <td className={n.equivalencia ? 'table-success' : 'table-danger'}>
                                                    {n.equivalencia ? 'APROBADO' : 'REPROBADO'}
                                                </td>
                                                <td>{n.asistencia}%</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}